import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React from "react";
import { useCallback } from "react";
import { DELETE_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { useToastContext } from "../../shared/ToastContext";
import { arrInvalid, handleError } from "../../../helper";
import { useAmazonIdeaCtx } from "../context";
import useTimeout from "../../../hooks/useTimeout";

export default function AmazonIdeaDelete({ open, onClose, ids, onCompleted }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [setDelay] = useTimeout();
    const [deleteAmazonIdea, { loading }] = useMutation(DELETE_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({ msg: "Delete amazon idea successfully", err: false });
            onClose();
            onCompleted && onCompleted();

            setDelay(() => {
                refetch && refetch();
            }, 1000);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;
        setNotify && setNotify({ msg: null, err: false });
        toggleToast && toggleToast(true);

        deleteAmazonIdea({
            variables: {
                ids,
            },
        });
    }, [ids, deleteAmazonIdea, setNotify, toggleToast]);

    return (
        <Modal
            open={open}
            title="Delete Amazon Idea"
            onClose={onClose}
            sectioned
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Delete",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <p>Are you sure to delete this idea?</p>
        </Modal>
    );
}
